import React, { forwardRef } from "react";
import AsyncSelect from "react-select/async";
import { selectStyles, ValidationText } from "..";

export const AsyncMultiSelect = forwardRef(
	(
		{
			onChange = () => {},
			placeholder = "Hello",
			disabled,
			loading,
			defaultInputValue,
			value,
			searchable,
			departmentId,
			id,
			apiOptions,
			isError = false,
			errorText = "",
			cacheOptions,
			...field
		},
		ref
	) => {
		const handleChange = async (value) => {
			const awaitedValue = await value;
			onChange(awaitedValue);
		};

		const handleLoadOptions = (query) =>
			departmentId ? apiOptions(query, departmentId) : apiOptions(query);

		return (
			<>
				<AsyncSelect
					{...field}
					placeholder={placeholder}
					onChange={handleChange}
					isDisabled={disabled}
					isLoading={loading}
					loadOptions={handleLoadOptions}
					cacheOptions={cacheOptions}
					styles={{
						...selectStyles({ isError }),
						menuPortal: (base) => ({
							...base,
							zIndex: 9999
						})
					}}
					ref={ref}
					menuPortalTarget={document.body}
				/>
				<div>
					{errorText.length > 0 && (
						<ValidationText status={"error"} message={errorText} />
					)}
				</div>
			</>
		);
	}
);
